<script>
  import Social from './Social'
  import Common from './Common'
  import Notif from './Notif'
  import moment from 'moment'

  const { VUE_APP_API_HOST, VUE_APP_LINKEDIN_APPID, VUE_APP_LINKEDIN_CALLBACK, VUE_APP_PINTEREST_CALLBACK, VUE_APP_GOOGLE_CLIENT_ID, VUE_APP_GOOGLE_SECRET, VUE_APP_GOOGLE_CALLBACK, VUE_APP_TIKTOK_APPID, VUE_APP_TIKTOK_CALLBACK, VUE_APP_YOUTUBE_CLIENT_ID, VUE_APP_YOUTUBE_REDIRECT, VUE_APP_INSTA_BUSINESS_ID, VUE_APP_INSTA_BUSINESS_REDIRECT, VUE_APP_THREADS_APPID, VUE_APP_THREADS_CALLBACK} = process.env
  const scope = ['r_organization_social', 'w_member_social', 'w_organization_social', 'r_basicprofile', 'r_emailaddress', 'r_liteprofile', 'rw_organization_admin']
  const CLIENT_ID_PINTEREST = '1474180'
  const RESPONSE_TYPE_PINTEREST = 'code'
  const SCOPE_PINTEREST = ['boards:read','pins:read','pins:write','boards:write','user_accounts:read']
  let SCOPE_TIKTOK = ['user.info.basic', 'video.list', 'video.upload', 'video.publish', 'user.info.stats', 'user.info.profile'];
  // const SCOPE_YOUTUBE = ['https://www.googleapis.com/auth/youtube', 
  //                         'https://www.googleapis.com/auth/youtube.channel-memberships.creator', 
  //                         'https://www.googleapis.com/auth/youtube.force-ssl',
  //                         'https://www.googleapis.com/auth/youtube.readonly',
  //                         'https://www.googleapis.com/auth/youtube.upload']
  const SCOPE_YOUTUBE = ['https://www.googleapis.com/auth/youtube', 'https://www.googleapis.com/auth/youtubepartner']
  // const SCOPE_YOUTUBE = ['https://www.googleapis.com/auth/youtube']
  // const SCOPE_THREADS = ['threads_basic', 'threads_content_publish', 'threads_read_replies', 'threads_manage_replies', 'threads_manage_insights']
  const SCOPE_THREADS = ['threads_basic', 'threads_content_publish']


  export default {
    mixins: [Social, Common, Notif],

    data() {
      return {
        pages: {
          facebook: [],
          twitter: [],
          linkedin: [],
          instagram: [],
          google: []
        },
      };
    },
    
    methods: {
      new(page) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/pages/`, page, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      newPage(page) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/pages/`, page, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      updatePage(page) {
        return this.$http
                   .put(`${VUE_APP_API_HOST}/pages/${page.id}`, page, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      updatePagesPosition(orderedPagesIds) {
        return this.$http
          .post(`${VUE_APP_API_HOST}/pages/position`, {orderedPagesIds}, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })
          .then(
            (res) => res,
            (err) => err
          )
      },

      delete(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/pages/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      deletePage(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/pages/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getPages(body) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
      },

      getAllPages(body) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages?all=true`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
      },

      getAvailibleTelegramBot() {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/telegram/bot`,
                     {
                      headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                    )
      },

      /**
       * Confirm Popup before refresh takes action
       * @param {Object} page Page Object
       */
      confirmRefresh(page) {
        console.log('confirmRefresh', page)
        if(["google", "youtube"].includes(page.network))
          this.notify({
              title: this.$t(`dash.refresh_token.${page.network}.remove-app.title`),
              text: this.$t(`dash.refresh_token.${page.network}.remove-app.content`),
              color: 'primary',
              id: 'repeat',
              time: 20000
            })

        this.$vs.dialog({
          type: 'confirm',
          color: '#501743',
          title: this.$t('dash.pages.refresh.title'),
          text: this.$t(`dash.pages.refresh.description${page.network == "twitter" ? '_twitter': ''}`),
          acceptText: "OK",
          accept: () => {
            this.$vs.loading({ color: 'primary' })
            this.refreshToken(page)
            this.$vs.loading.close()
          }
        })
      },

      /**
       * Refresh Token
       * @param {Object} page Page Object
       */
      refreshToken(page) {
        console.log('page', page)
        if (page.network == 'twitter') {
          // return this.connectTwitter({ refresh: true, version: 1 })
          return this.connectTwitter({ refresh: true, version: 2, page: page.id })
        } else if (page.network === 'linkedin') {
          return this.connectLinkedin({ refresh: true })
        } else if (page.network === 'pinterest'){
          return this.connectPinterest({ refresh:true })
        } else if (page.network === 'google'){
          return this.connectGoogle(page)
        } else if (page.network === 'youtube'){
          return this.connectYoutube({ refresh:true })
        } else if (page.network === 'threads'){
          return this.connectThreads({ refresh:true })
        } else if (page.network === 'tiktok'){
          return this.connectTiktok({ refresh:true })
        }else if (['facebook', 'instagram'].includes(page.network)) {
          let refreshConcernedPage = false
        //} else if (page.network == 'facebook') {
          let pages = localStorage.pages ? JSON.parse(localStorage.pages) : [page]
          // eslint-disable-next-line
          FB.login(response => {
            if (response.status !== 'connected') {
              console.error(`Could not connect to fb. ${JSON.stringify(response)}`)
              return
            }

            const uid = (response.authResponse && response.authResponse.userID)
              || null
            const accessToken = response.authResponse.accessToken
            if (!accessToken)
              throw Error(`Could not get fb access token. ${JSON.stringify(response)}`)

            const expireDateToken = response.authResponse.data_access_expiration_time
            try {
              this.getUserInfoFb(accessToken).then(res => {
                if (!res.ok)
                  throw Error(res.statusText)

                this.getLongLiveToken(accessToken).then(res => {
                  if (!res.ok)
                    throw Error(res.statusText)

                  const body = { id: uid, token: res.body.access_token }
                  let pagesFB = []
                  this.retrievePages(body.token).then(async res => {
                    if (!res.ok)
                      throw Error(res.statusText)

                    let nextPagesEndpoint = res.body.paging && res.body.paging.next ? res.body.paging.next : null

                    pagesFB = res.body.data
                    while(nextPagesEndpoint){
                      await this.$http.get(nextPagesEndpoint)
                        .then(async nextPages => {
                          console.log('next', nextPages)
                          nextPagesEndpoint = nextPages.body.paging && nextPages.body.paging.next ? nextPages.body.paging.next : null
                          pagesFB = pagesFB.concat(nextPages.body.data)
                        })
                        .catch(e => {
                          console.log('err', e)
                          nextPagesEndpoint = null
                        })
                    }

                    if(page.network == 'instagram') {
                      this.pages.instagram = []

                      // Promise.all(res.body.data.map(async p => {
                      Promise.all(pagesFB.map(async p => {
                        console.log('Promise retrievePages Insta')
                        await this.retrieveInstaPages(p.id, body.token).then(async resInstaPages => {
                          console.log('resInstaPages general', resInstaPages)
                          if(resInstaPages.body.instagram_business_account) {
                            console.log('resInstaPages', resInstaPages.body)

                            let messageLog = `resInstaPages --- ${JSON.stringify(resInstaPages)}`
                            this.addLog(JSON.parse(localStorage.user), 'refresh-token', messageLog)

                            await this.getUserInfoInsta(resInstaPages.body.instagram_business_account.id, body.token).then(async resInfoInsta => {
                              console.log('resInfoInsta', resInfoInsta, resInfoInsta.body.id, resInfoInsta.body.id == page.network_id)
                              
                              messageLog = `resInfoInsta --- network_id=${page.network_id} --- name=${page.name} --- ${JSON.stringify(resInfoInsta)}`
                              this.addLog(JSON.parse(localStorage.user), 'refresh-token', messageLog)
                                                      
                              // if(resInfoInsta.body.id == page.network_id || (resInfoInsta.body.username === page.name && page.isGroup)){
                              //   this.new({
                              //     network: 'instagram',
                              //     network_id: resInfoInsta.body.id,
                              //     name: resInfoInsta.body.username,
                              //     token: body.token,
                              //     affected_to: p.id,
                              //     avatar : resInfoInsta.body.profile_picture_url || null,
                              //   }).then(() => {
                              //     this.$vs.loading.close()
                              //     this.$vs.dialog({
                              //       color: 'primary',
                              //       title: this.$t('dash.pages.refresh.title'),
                              //       text: this.$t('dash.pages.refresh.success'),
                              //       acceptText: "OK",
                              //       accept: () => {
                              //         location.href = '/#/dash/pages'
                              //       }
                              //     })
                              //   }, err => { throw err })
                              // }  

                              // Username match also catches API pages whose network_id was overwritten by the conciergerie pk
                              if(pages.find(pp => resInfoInsta.body.id == pp.network_id || (resInfoInsta.body.username === pp.name && (pp.isGroup || pp.network === 'instagram')))){
                                if(resInfoInsta.body.id == page.network_id || resInfoInsta.body.username === page.name)
                                  refreshConcernedPage = true
                                await this.new({
                                  network: 'instagram',
                                  network_id: resInfoInsta.body.id,
                                  name: resInfoInsta.body.username,
                                  token: body.token,
                                  affected_to: p.id,
                                  avatar : resInfoInsta.body.profile_picture_url || null,
                                })
                              }
                            })
                            
                          }
                        })
                      }))
                      .then(() => {
                        this.$vs.loading.close()
                        this.$vs.dialog({
                          color: 'primary',
                          title: this.$t('dash.pages.refresh.title'),
                          text: refreshConcernedPage ? this.$t('dash.pages.refresh.success') : this.$t('dash.pages.refresh.failed'),
                          acceptText: "OK",
                          accept: () => {
                            // location.href = '/#/dash/pages'
                            location.assign('/#/dash/pages')
                            location.reload()
                          }
                        })
                      }, err => { throw err })

                    } else if(page.isGroup) {
                      this.retrieveGroups(uid, body.token).then(async resGroups => {
                        if (!resGroups.ok)
                          throw Error(resGroups.statusText)

                        this.pages.facebook = []
                        // let concerned = resGroups.body.data.find(p => p.id == page.network_id)

                        // this.new({
                        //   network: 'facebook',
                        //   network_id: concerned.id,
                        //   //token: concerned.access_token,
                        //   token: body.token,
                        //   expires_at: expireDateToken,
                        //   avatar: concerned.picture && concerned.picture.data && concerned.picture.data.url
                        //           ? concerned.picture.data.url
                        //           : null,
                        //   name: concerned.name
                        // }).then(() => {
                        //   this.$vs.loading.close()
                        //   this.$vs.dialog({
                        //     color: 'primary',
                        //     title: this.$t('dash.pages.refresh.title'),
                        //     text: this.$t('dash.pages.refresh.success'),
                        //     acceptText: "OK",
                        //     accept: () => {
                        //       location.href = '/#/dash/pages'
                        //     }
                        //   })
                        // }, err => { throw err })

                        // await Promise.all(resGroups.body.data.filter(pFb => pages.find(pp => pFb.id == pp.network_id)).map(async concerned => {
                        for(let concerned of resGroups.body.data.filter(pFb => pages.find(pp => pFb.id == pp.network_id))) {
                          if(concerned.id == page.network_id)
                            refreshConcernedPage = true
                          await this.new({
                            network: 'facebook',
                            network_id: concerned.id,
                            token: body.token,
                            expires_at: expireDateToken,
                            avatar: concerned.picture && concerned.picture.data && concerned.picture.data.url
                                      ? concerned.picture.data.url
                                      : null,
                            name: concerned.name
                          })
                        }
                        // }))
                        // .then(() => {
                          this.$vs.loading.close()
                          this.$vs.dialog({
                            color: 'primary',
                            title: this.$t('dash.pages.refresh.title'),
                            text: refreshConcernedPage ? this.$t('dash.pages.refresh.success') : this.$t('dash.pages.refresh.failed'),
                            acceptText: "OK",
                            accept: () => {
                              // location.href = '/#/dash/pages'
                              location.assign('/#/dash/pages')
                              location.reload()
                            }
                          })
                        // }, err => { throw err })

                      })
                    } else {
                      this.pages.facebook = []
                      // let concerned = pagesFB.find(p => p.id == page.network_id)
  
                      // this.new({
                      //   network: 'facebook',
                      //   network_id: concerned.id,
                      //   token: concerned.access_token,
                      //   expires_at: expireDateToken,
                      //   avatar: concerned.picture && concerned.picture.data && concerned.picture.data.url
                      //             ? concerned.picture.data.url
                      //             : null,
                      //   name: concerned.name
                      // }).then(() => {
                      //   this.$vs.loading.close()
                      //   this.$vs.dialog({
                      //     color: 'primary',
                      //     title: this.$t('dash.pages.refresh.title'),
                      //     text: this.$t('dash.pages.refresh.success'),
                      //     acceptText: "OK",
                      //     accept: () => {
                      //       location.href = '/#/dash/pages'
                      //     }
                      //   })
                      // }, err => { throw err })

                      // await Promise.all(pagesFB.filter(pFb => pages.find(pp => pFb.id == pp.network_id)).map(async concerned => {
                      for(let concerned of pagesFB.filter(pFb => pages.find(pp => pFb.id == pp.network_id || (pp.story_config && pp.story_config.onlyConciergerie && pp.network === 'facebook' && pFb.name === pp.name)))) {
                        if(concerned.id == page.network_id || (page.story_config && page.story_config.onlyConciergerie && concerned.name === page.name))
                          refreshConcernedPage = true

                        if(concerned.parent_page && concerned.parent_page.id && concerned.location && concerned.location.city)
                          concerned.name += ` (${concerned.location.city})`

                        await this.new({
                          network: 'facebook',
                          network_id: concerned.id,
                          token: concerned.access_token,
                          expires_at: expireDateToken,
                          avatar: concerned.picture && concerned.picture.data && concerned.picture.data.url
                                    ? concerned.picture.data.url
                                    : null,
                          name: concerned.name
                        })
                      }
                      // }))
                      // .then(() => {
                        this.$vs.loading.close()
                        this.$vs.dialog({
                          color: 'primary',
                          title: this.$t('dash.pages.refresh.title'),
                          text: refreshConcernedPage ? this.$t('dash.pages.refresh.success') : this.$t('dash.pages.refresh.failed'),
                          acceptText: "OK",
                          accept: () => {
                            // location.href = '/#/dash/pages'
                            location.assign('/#/dash/pages')
                            location.reload()
                          }
                        })
                      // }, err => { throw err })
                    }

                  }, err => { throw err })
                }, err => { throw err })
              }, err => { throw err })
            } catch (err) {
              this.dialog.title = 'Error'
              this.dialog.message = err.message || 'Server not responding…'
              this.dialog.show = true

              this.$vs.dialog({
                color: 'primary',
                title: this.$t('dash.pages.refresh.title'),
                text: this.$t('dash.pages.refresh.failed'),
                acceptText: "OK",
                accept: () => {
                  // location.href = '/#/dash/pages'
                  location.assign('/#/dash/pages')
                  location.reload()
                }
              })
            }
          }, {
            scope:
              //'public_profile, pages_show_list, publish_pages, manage_pages, read_insights',
              //'public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content',
              
              //`public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content ${page.network == 'instagram' ? ', instagram_basic, instagram_content_publish, instagram_manage_insights' : (page.isGroup ? ',publish_to_groups' : ',pages_manage_metadata')}`,
              // `public_profile, pages_show_list, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content ${page.network == 'instagram' ? ', instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments' : (page.isGroup ? ',publish_to_groups' : ',pages_manage_metadata')}`,
            `public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content, business_management ${page.network == 'instagram' ? ', instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages, pages_messaging' : (page.isGroup ? ',publish_to_groups' : ', pages_messaging, instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages')}`,
            // `public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, read_insights, pages_manage_posts, pages_manage_engagement, pages_read_user_content ${page.network == 'instagram' ? ', instagram_basic, instagram_content_publish, instagram_manage_insights, instagram_manage_comments, instagram_manage_messages' : (page.isGroup ? ',publish_to_groups' : ', pages_messaging, business_management')}`,
            return_scopes: true
          })
        }
      },

      connectInstaBusiness() {
        window.location.href = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=${VUE_APP_INSTA_BUSINESS_ID}&redirect_uri=${VUE_APP_INSTA_BUSINESS_REDIRECT}&response_type=code&scope=business_basic%2Cbusiness_manage_messages%2Cbusiness_manage_comments%2Cbusiness_content_publish&state=ig_business-connect`
      },

      connectGoogle (page) {
        let pages = localStorage.pages ? JSON.parse(localStorage.pages) : [page]
        this.$vs.loading({ color: 'primary'})
        this.$gAuth.getAuthCode()
        .then(async authCode => {
          console.log('authCode', authCode)
          //let { pages } = this.getTokensGoogle(authCode)
          let res = await this.getTokensGoogle(authCode)
          if(res && res.body && !res.body.success)
            return console.log('error')
          console.log('pages', res.body.pages)
          // let pageToUpdate = res.body.pages.find(p => p.network_id == page.network_id)
          // if(!pageToUpdate)
          //   return console.log('error pageToUpdate not find')

          // let body = {
          //   'name': pageToUpdate.name,
          //   'network': pageToUpdate.network,
          //   'network_id': pageToUpdate.network_id,
          //   'avatar': pageToUpdate.avatar
          // }
          
          // if(['instagram', 'google'].includes(pageToUpdate.network)) body['affected_to'] = pageToUpdate.affected_to || null
          
          // if(pageToUpdate.isGroup) body['isGroup'] = true

          // if (pageToUpdate.access_token)
          //   body['token'] = pageToUpdate.access_token

          // if(pageToUpdate.network == 'google')
          //   body['expires_at'] = moment().add(pageToUpdate.expires_at, 'seconds').format()
          // else if (pageToUpdate.expires_at)
          //   body['expires_at'] = pageToUpdate.expires_at
          
          // if (pageToUpdate.refresh_token)
          //   body['refresh_token'] = pageToUpdate.refresh_token


          // this.new(body).then(() => {
          //   this.$vs.loading.close()
          //   this.$vs.dialog({
          //     color: 'primary',
          //     title: this.$t('dash.pages.refresh.title'),
          //     text: this.$t('dash.pages.refresh.success'),
          //     acceptText: "OK",
          //     accept: () => {
          //       location.href = '/#/dash/pages'
          //     }
          //   })
          // }, err => { throw err })

          // await Promise.all(res.body.pages.filter(pGoogle => pages.find(pp => pGoogle.network_id == pp.network_id)).map(pageToUpdate => {
          for(let pageToUpdate of res.body.pages.filter(pGoogle => pages.find(pp => pGoogle.network_id == pp.network_id))) {
            let body = {
              'name': pageToUpdate.name,
              'network': pageToUpdate.network,
              'network_id': pageToUpdate.network_id,
              'avatar': pageToUpdate.avatar
            }
            
            if(['instagram', 'google'].includes(pageToUpdate.network)) body['affected_to'] = pageToUpdate.affected_to || null
            
            if(pageToUpdate.isGroup) body['isGroup'] = true

            if (pageToUpdate.access_token)
              body['token'] = pageToUpdate.access_token

            if(pageToUpdate.network == 'google')
              body['expires_at'] = moment().add(pageToUpdate.expires_at, 'seconds').format()
            else if (pageToUpdate.expires_at)
              body['expires_at'] = pageToUpdate.expires_at
            
            if (pageToUpdate.refresh_token)
              body['refresh_token'] = pageToUpdate.refresh_token
            
            await this.new(body)
          }
          // }))
          // .then(() => {
            this.$vs.loading.close()
            this.$vs.dialog({
              color: 'primary',
              title: this.$t('dash.pages.refresh.title'),
              text: this.$t('dash.pages.refresh.success'),
              acceptText: "OK",
              accept: () => {
                // location.href = '/#/dash/pages'
                location.assign('/#/dash/pages')
                location.reload()
              }
            })
          // }, err => { throw err })

        })
      },

      /**
       * Connect Linkedin user, get the redirection link
       */
      connectLinkedin({ refresh = false }) {
        this.$ga.event('pages', 'connect-linkedin')
        // if (location.href.includes('/pages') && !refresh)
        if (!refresh)
          localStorage.setItem('linkedin_adding_page', true)
        
        console.log('linkedin_adding_page', localStorage.getItem('linkedin_adding_page'))

        const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${
          VUE_APP_LINKEDIN_APPID
          }&redirect_uri=${
          VUE_APP_LINKEDIN_CALLBACK
          }&scope=${scope.join('%20')}`
        window.location.href = url
      },

      /**
       * Connect Pinterest user, get the redirection link
       */
      connectPinterest(){
      this.$ga.event('pages', 'connect-pinterest')

        console.log('mixin page connectPinterest')
        const url = `https://www.pinterest.com/oauth?response_type=code&client_id=${
          CLIENT_ID_PINTEREST
          }&redirect_uri=${
          VUE_APP_PINTEREST_CALLBACK
          }&scope=${SCOPE_PINTEREST}`
        window.location.href = url
      },

      
    connectYoutube(){
      this.$ga.event('pages', 'connect-youtube')

      console.log('mixin page connectYoutube')
      const url = `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodeURIComponent(SCOPE_YOUTUBE.join(' '))}&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=${encodeURIComponent(VUE_APP_YOUTUBE_REDIRECT)}&response_type=code&access_type=offline&client_id=${VUE_APP_YOUTUBE_CLIENT_ID}&prompt=consent`
      window.location.href = url
    },

    connectThreads() {
      this.$ga.event('pages', 'connect-threads')

      console.log('mixin page connectThreads')
      const url = `https://threads.net/oauth/authorize?client_id=${process.env.VUE_APP_THREADS_APPID}&redirect_uri=${process.env.VUE_APP_THREADS_CALLBACK}&scope=${encodeURIComponent(SCOPE_THREADS.join(','))}&response_type=code&state=threads-connect`
      window.location.href = url
    },

      getTokensGoogle(authCode){
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/google/access?authCode=${authCode}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },

      /**
       * Connect Telegram user, get the redirection link
       */
      connectTelegram({ refresh = false}, channelUrl, botName) {
        console.log(channelUrl);
        let channelId = channelUrl.replace('https://t.me/', '@');
        console.log("connectTelegram", channelId);

        this.newPage({
          network: 'telegram',
          network_id: channelId,
          botName
        }).then(async res => {
          console.log(res);
          // mixin also used without the User mixin
          if (this.refreshUserInfos) await this.refreshUserInfos()
          location.assign('/#/dash/pages')
          location.reload();
        });
      },

      /**
       * Connect Twitter user, get the redirection link
       */
      // connectTwitter({ refresh = false, version = 1 }) {
      connectTwitter({ refresh = false, version = 2, page = null }) {
        this.$ga.event('pages', 'connect-twitter')
        // if (location.href.includes('/pages') && !refresh)
        if (!refresh)
          localStorage.setItem('twitter_adding_page', true)

        // Si refresh à true récupérer l'id de la page pour utiliser la bonne app côté engine sur les retour en callback url de tw
        if(refresh && page)
          localStorage.setItem('refresh_twitter_page', page)

        this.getTwitterRedirectLink({version, page}).then(res => {
          if (!res || !res.data)
            return this.$vs.dialog({
              color: 'danger',
              title: `Error`,
              text: 'Problem with Twitter Connect',
              acceptText: "OK"
            })

          window.location.href = res.data.url
        })
      },

      /**
       * Connect Tiktok user, get the redirection link
       */
      connectTiktok({ refresh = false }) {
        this.$ga.event('pages', 'connect-tiktok')
        // if (location.href.includes('/pages') && !refresh)
        const csrfState = Math.random().toString(36).substring(2);
        if (!refresh)
          localStorage.setItem('tiktok_adding_page', csrfState)
        
        console.log('tiktok_adding_page', localStorage.getItem('tiktok_adding_page'))
        const url = `https://www.tiktok.com/v2/auth/authorize/?response_type=code&client_key=${VUE_APP_TIKTOK_APPID}&redirect_uri=${encodeURIComponent(VUE_APP_TIKTOK_CALLBACK)}&scope=${encodeURIComponent(SCOPE_TIKTOK.join(','))}&state=${csrfState}`
        window.location.href = url
      },

      getTiktokUrl(pageId) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/tiktok/link?id=${pageId}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },

      getPageNameByApi(id, network_id) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/name?id=${id}&network_id=${network_id}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },

      disconnectDirectApi(pageId, reason="manual disconnection") {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/conciergerie/disconnect?id=${pageId}&reason=${encodeURI(reason)}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },

      checkLockDirectApi(page) {
        if(!page.story_config) return { locked: false };
        console.log(page.story_config);
        if (!page.story_config.lock) {
          return { locked: false };
        }
        if (page.story_config.lock <= Date.now()) {
          return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/conciergerie/lock?id=${page.id}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => {
                      return { locked: false};
                   }, err => err)
        } else {
          return { locked: true};
        }

      },

      getReportingApiUrl(pageId) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/reporting/api/url?pageId=${pageId}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
      },

      getReportingPDF(pageId, dateStart, dateEnd, timezone, language) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/reporting/pdf?pageId=${pageId}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezone=${timezone}&language=${language}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      addConcurrentToPage(pageId, concurrent) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/reporting/concurrent`, {pageId, concurrent}, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      removeConcurrentToPage(pageId, concurrent) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/reporting/concurrent?pageId=${pageId}&concurrent=${concurrent.id || concurrent.name}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      linkedinProfile(page) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/linkedin/user?page=${page}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      checkConciergerie(page) {
        switch (page.network) {
          case 'instagram':
            return page.story_config && page.story_config.created
          case 'linkedin':
            return page.bot_status && page.story_config && page.story_config.created
          case 'tiktok':
            return page.story_config && page.story_config.created
          default:
            return false
        }
      }    
    }
  }
</script>
